import styled from 'styled-components'
import { colors } from 'app-v2/design-systems/theme'
import { SPACING } from 'app-v2/design-tokens'

export const StyledMainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${colors.white};
    align-items: center;
    height: 100%;
`

export const StyledBackground = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${colors.fieryRed};
    padding: ${SPACING.XXL};
    padding-top: 100px;
    align-items: center;
    width: 100%;
`

export const StyledInfoContainer = styled.div`
    padding: ${SPACING.XXL};
`

export const StyledButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: ${SPACING.S};
    width: calc(100% - ${SPACING.XXL});
    max-width: 450px;
`
